import React from 'react';
import SAdminDashboard from '../components/dashboard/SAdminDashboard';

const SAdminDashboardPage = () => {
  return (
    <div className="min-h-screen">
      <SAdminDashboard />
    </div>
  );
};

export default SAdminDashboardPage;
